<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo.png" />
        <div class="enterprise">戈公航运</div>
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="[index == navIndex ? 'active' : '']"
          @click="navClick(index, item)"
        >
          <router-link :to="item.path">
            {{ item.meta.title }}
            <span
              v-if="item.children && item.children.length > 0"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline"></i>
          </router-link>
          <dl
            v-if="item.children && item.children.length > 0"
            class="animated fadeIn"
            style="-webkit-animation-duration: 0.8s"
          >
            <dt
              v-for="(cItem, cIndex) in item.children"
              :key="cIndex"
              @click.stop="subNavClick(item, index, cItem, cIndex)"
              :class="[subIndex == cItem.path ? 'active' : '']"
            >
              <router-link :to="cItem.path">{{ cItem.meta.title }}</router-link>
            </dt>
          </dl>
        </li>
        <li style="font-size: 15px">
          <i class="glyphicon glyphicon-earphone"></i>0770-6688899
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo.png" alt="logo" />
        <div class="enterprise">戈公航运</div>
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="[index == navIndex ? 'active' : '']"
            @click="navClick(index, item)"
          >
            <router-link :to="item.path">
              {{ item.meta.title }}
              <span
                v-if="item.children && item.children.length > 0"
                class="glyphicon glyphicon-menu-down"
              ></span>
              <i class="underline"></i>
            </router-link>
            <dl v-if="item.children && item.children.length > 0">
              <dt
                v-for="(cItem, cIndex) in item.children"
                :key="cIndex"
                @click.stop="subNavClick(item, index, cItem, cIndex)"
                :class="[subIndex == cItem.path ? 'active' : '']"
              >
                <router-link :to="cItem.path">{{
                  cItem.meta.title
                }}</router-link>
              </dt>
            </dl>
          </li>
          <li style="font-size: 15px">
            <i class="glyphicon glyphicon-earphone"></i>
            0770-6688899
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { routes } from "@/router/index.js";
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      subIndex: "",
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
    };
  },
  computed: {
    navList() {
      return routes.filter((item) => !item.hidden);
    },
    mNavList() {
      let arr = [];
      this.navList.forEach((item) => {
        if (item.children && item.children.length) {
          console.log(item.children);
          arr = [...arr, ...item.children];
        } else {
          arr.push(item);
        }
      });
      return arr;
    },
  },
  methods: {
    navClick(index, item) {
      this.navIndex = index;
      this.subIndex = "";
      this.menuName = item.meta.title;
      sessionStorage.setItem("navIndex", index);
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    subNavClick(item, index, cItem, cIndex) {
      this.navIndex = index;
      this.subIndex = cIndex;
      this.menuName = cItem.meta.title;
      sessionStorage.setItem("navIndex", index);
    },
  },
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 60px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 140px;
  height: 100%;
  float: left;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  height: 40px;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo .enterprise {
  height: 40px;
  line-height: 40px;
  font-size: 22px;
  font-weight: bold;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 60px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #396afc;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #396afc;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #396afc;
  text-decoration: none;
  border-bottom: 2px solid #396afc;
}
#header .header-nav .header-nav-wrapper dt.active a {
  color: #396afc;
  text-decoration: none;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 220px;
  top: 100%;
  left: 0;
  z-index: 999999;
  /* box-shadow: 0 0 3px 1px #ccc; */
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  border-bottom: 1px solid #ccc;
  transition: all ease 0.5s;
}
#header .header-nav .header-nav-wrapper > li > dl > dt > a {
  display: block;
  padding: 10px;
  color: #666;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  color: #396afc;
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    width: 140px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: auto;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    height: 35px;
  }
  #header .header-nav-m .header-nav-m-logo .enterprise {
    height: 35px;
    line-height: 35px;
    font-size: 22px;
    font-weight: bold;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #190000;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #190000;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    min-height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的二级导航容器 */
  #header .header-nav-m .header-nav-m-wrapper > li > dl {
    margin-bottom: 0px;
    background: #ffffff17;
    font-size: 14px;
  }
  /* 导航栏 每个导航下面的二级导航容器的每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li > dl > dt {
    width: 100%;
    border-bottom: 1px solid #ccc;
    transition: all ease 0.5s;
  }
  #header .header-nav-m .header-nav-m-wrapper > li > dl > dt > a {
    display: block;
    padding: 10px;
    color: #fff;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav-m .header-nav-m-wrapper > li > a > span {
    font-size: 10px;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue